export const defaultDatabase = [
  {
    label: 'Ionization',
    rxnCode:
      'gCh@IGZ@~d^Lf\\@`D_yIP!gChAIIcm@_RWFSN@PB@#qTq qTq#!Rm?w~@Hc}G_I| !Rm?w~@Hc}G]i|',
    ionization: 'esiPositive',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eM`BN`~b|b`!eM``fN`~cP#Qg Qg#!R_qL@DqvJ_@ !R_qL@DqwZ_@',
    ionization: 'esiPositive',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ionization',
    rxnCode:
      'eMHBN`~axp``D_yE@!eMH`fN`~bxp``D@#Qg Qg#!R_qL@DqvJ_@ !R_qL@Dqtz_@',
    ionization: 'esiPositive',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eF`BLGt[dT!eF``fLFD@#Qd Qd#!R@AL]Rgp !R@AL]vop',
    ionization: 'esiPositive',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFHBLGtWFDD@cHh!eFH`fLGt[FDD@`#Qd Qd#!R@FL]Rgp !R@FL]vgp',
    ionization: 'esiPositive',
    reaction: 'ionization',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ionization',
    rxnCode: 'eFBCDcAcBQFIdT!eFBcDIcA}EqaHcD@#QX QX#!R@FL]bgp !R@FL]vgp',
    ionization: 'esiPositive',
    reaction: 'ionization',
    doi: '',
    section: '5',
    description: 'Fig. 10',
    kind: 'ionization',
    web: 'https://www.orgchemboulder.com/Spectroscopy/MS/fragmech.shtml',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Elimination',
    rxnCode: 'eMHAIhOdm`!fI@Guh eF@HhP#Qg a` Qt#!R@Fp@XqvJ_@ !RG]i| !R@FL]^kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 1',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Halide Elimination',
    rxnCode:
      'eMBGDchOjbLiDX`!fHfHA}QFRHq@ eF@HhP#Q[ Qp Qd#!R_qL@TqurO@ !RGUi| !R@FL]^kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 1',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Formation of stabilized cations',
    rxnCode:
      'deT@@DjUijP`j@@`!fH@O~U@ did@BLeJeYhP`h@B#IaLJfxYT qx IaLJfFU#!Rqyu^@La]q?sG?OsHg\\^HgUx@GSI| !RGYi| !RWb?G?Lc|quwGW\\a]W`CG?Auz?@',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 2',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Formation of stabilized cations',
    rxnCode:
      'deT@@DjUijP`j@@vqnGH[@!fH@Mh fH@Mh daD@BLeJeVnBB@@va`#IaLJfxYT ID qx IaLJfeP#!R~qt^@H`]~?s{?Nw{bAw|bAx@G_I| !RGTXB !RGRZ| !R{g?W[LAlu?wW?\\C}uvp]nkp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 2',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amines fragmentation',
    rxnCode:
      'gJXA@IRij`MUEIP!eM`BN`uQTh eF@bXpP#qLkP qMX Qd#!RdArwGMy?dCt]\\kp !R[pL@@quZo@ !R_wP]^op',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 3',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amines fragmentation',
    rxnCode:
      'gJXA@IRij`MUEIP!eM``fN`~bJhjT eF@HhP#qVah qQ` qu#!RtErwWCy?tKt]\\kp !RGtL@PquZo@ !R@DL]~kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 4 ',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amines fragmentation',
    rxnCode:
      'gGXA@IrRHuTAjhiJ@!gChA@Icm@ZjJR` eF@HpP#qQfk qQt q]#!RbCwgOSx@bOrHOQwr?@ !Ryst~@H`}G]k| !R@DL]~kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 5',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amides fragmentation',
    rxnCode:
      'gGYADEJSLuPFjrbh!eM`BN`uQTh eMHbeIXH#qiSf Q[ qiX#!Rog~wo[B}msr~_qvrG@ !R[E}l@AuZ_@ !RSG|S_quzW@',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 6',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amides fragmentation',
    rxnCode:
      'gGYADEJSLuPFjrbh!eM``fN`~bJhjT eMHAITH#qbqk quX qbH#!RbCvH@cx_O`BHOQuro@ !RGtL@PqvZo@ !R_sy?Oavz_@',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amides fragmentation',
    rxnCode:
      'gGYADEJSLuPFjrbh!gJY@DDefhCUIVT fHT`P#qbqk qbsh qH#!R_`CW?Hc|uwu~@AwRp` !RbGvH@gx@bGt]Nop !RG_k|',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 8',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amides fragmentation',
    rxnCode:
      'gGYADEJSLuPFlr`!gJY@DDfVhCVYP fHT`P#qbsi qbsh qH#!RbOrHo[x@oe~H?AtJ?@ !RlOvpOKy?lKt]Nmp !RG_k|',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 9',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amides fragmentation',
    rxnCode:
      'gNyADEJSMmU@Zpj@!gJYADEJSKTA}EEYe@ eF@HhP#qbq]x qbqh q{#!Rb@JH_Wx@bOq~Oxa}GPk| !R_g~w?_C}mwp]Vmp !R_rp]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 10',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gJPa@eJSKTA}E@!eMHbeIXH eFHBLGtX#qrLh Qv qM#!R`W~GkQSuavH]tep !R`W}LeQvZW@ !R_rP]^op',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 11',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gGPa@eJSNuPGtT@!gC`a@eJSM@_QX eF@HhP#satpj satp qi#!RbOrH_Wx@b@JH_QtJ`` !Rb@JH_Wx@GSjB !R_rp]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 12',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gGPa@eJSNuPGtT@!gC``@dfZ@~b` eF@bXpP#qbqk qbq qk#!RbOrH_Wx@b@JH_Qwr`` !Rb@JH_Wx@GSjB !R@FL]~kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 13',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gGPa@eJSJuPGtT@!gC``@deZ@` eF@bXpP#qbqk qbu qK#!R_`CW?Hc|uwvH_QwR`` !R@FL@[@AcGSj| !R_rp]~op',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 14',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gJPa@eJSKTA}E@!eMHAITH eFH`fLGtX#qbqh qbH qu#!RbOvH@oy?bOt]|mp !R_?y??atZ_@ !R@AL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 15',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Carbamates fragmentation',
    rxnCode:
      'gNxaLDiRYYjhCzJ@!gJYADIJRsTA@ eFHBLGtP#qbqkx qbKx qu#!R_`CW?Hc|uwu~@Ha}G]KB !Rmwrw_[]|_g|]fkp !R@FL]~kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 16A & B',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Carbamates fragmentation',
    rxnCode:
      'gNxaLDiRYYjhCzJ@!gJY@DDefhB eFH`fHGtWVD@#qbqkx qbKx qu#!R_`CW?Hc|uwu~@Ha}G]KB !Rmwrw_[]|_g|]Fkp !R@FL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 17',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Carbamates fragmentation',
    rxnCode:
      'dazDBLADeIeejj@OhR@!gGXaLDiR[fj@~bp eF@HhP#IaLJfxP qbq_ IF`#!Rog~po[^}lCrwOKy?lOt]lap !RbKv~Wx`Bo`BHoQvzo@ !R_tp]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 18',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiocarbamates fragmentation',
    rxnCode:
      'gNyIC`DB\\dTLij@~``!gJYADIJRsTA@ eFB@HcA}D@#qbqkx qJkx Ql#!RBKuWo[{_BOpHoWx@GWJ| !R?`A\\Zere_`p]vlH !R_yt]~kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 19',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiocarbamates fragmentation',
    rxnCode:
      'dazHbBp@`IRf^ij`Cz@`!gGYIL`DBTfzZ`OhL@ eF@HhP#IaLJa[` qbM{ IG@#!Ru?rH?Gx@uwvH_]\\B_c|]Top !Ru?q~@M]}upI~OquZ?@ !R@FL]Agp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 20',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiocarbamates fragmentation',
    rxnCode:
      'dazHbBp@`irQPqTuPA}AP!gGYHC`DYHhZZ@~a` eF@bXpP#IaLJnXP qbqk IxP#!Rb@KW@gx@bGvH?Gx?bGt]\\op !R|Gvw_Wy?|Gsp_Qtzw@ !R_rp]Aop',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 21',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiocarbamates fragmentation',
    rxnCode:
      'gNyIC`DB\\dTLij@~``!gCaHL@aJZPH eM``fM`~b@#qbqkx qbq qoX#!RbGwW_Wx?b@I~@Ha}G[J| !ROvL@Xs}lGYj| !R@FL?Xqwzo@',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 22',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'gGTAAaJTwTpGrFZHphHA@!gCh@@eKHFLrB@P eF``fLGt\\#qn\\J qfQ qk#!Rm?wp?[]|_g~w?Qtrw@ !R_`BH_Wx@G]jB !RE`@]^`H',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 23',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'gG\\A@liRYVj@~paYh@!gCd@AdiY@~f` eF``fLGt\\#qjas qJ] Ql#!R?`BH?M]||GwW_Qvr`` !Ro`BHo[x@G]jB !Ry`@]^`H',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 23',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'gNtA@QNRQPuS@_HPXcJ``D@!gCh@@eKHFLrB@P eM``fN`~c@#qbqkx qj{ qap#!Re{v~@Hb}epJ~Wy^}G^J| !R_{x|lG~~GQhB !RWrL@Hqwzo@',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 24',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'gN|A@liRYejhC{BEF`!gCd@AdiY@~f` eM``fN`~c@#qbqkx qJ| qsh#!R_dCH?N_|O`BHO^\\}G]KB !R_sy\\tG|~GYhB !RGtL@Pqwzo@',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 24',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'day@B@HIRigjf`Cy@`hcEHHA@!gGT@Adini`OhHcB``D@ eF@bXpP#IaLJfxP IiAab qw#!RbKvWo[x@bOr~Wy_|bKt]Lcp !RlKvwo[@|og~poQtzw@ !R@BL]Akp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 25',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'da{@B@SDeIfUjj@OlBDcH@!gG\\@@ldrmTA|aB` eF@bXpP#IYHkBG` IYJ`R qw#!R?dCW?Hc|e{v~@Hb}e?p]dlH !R?`Bw@oA|u{wpoQwZ`` !R@BL]Akp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 25',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'gNtA@SNRQPuS@_PyFUA@H@!gJXAAIRijPLXTD@` eF`BLGtX#qbqkx qbNX qo#!RbKvWo[x@b@J~Wxb}G[H| !Re{v~@Hb}e?p]fop !R_tp]~op',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 26',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'gN|A@miRYejhCyBM`!gJTA@iJRsTA}A@ eF`BLGtX#qZeqx qZap qo#!R_`CW?Hc|uwu~@Ha}GUKB !Rmwrw_[]|_g|]fkp !R@FL]Akp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 26',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'day@B@HIRigjf`Cy@`hcEHHA@!gGTAAaJTwTpGrFZHphHA@ eF@HhP#IaLJfxP IaBia q~#!RbKvWo[x@bOr~Wy_|bKt]Lkp !R}pNpo_]|og~woQuZw@ !R_vp]Agp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 27',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ureas fragmentation',
    rxnCode:
      'da{@B@SDeIfUjj@OlBDcH@!gG\\A@liRYVj@~paYh@ eF@HhP#IYHkBG` IYHha q~#!R@RCW@hc|yst~@H`}y?p]TlH !R@PCp_K]|lCwWOQwZ`` !R_rp]Agp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 27',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Acyl urea fragmentation',
    rxnCode:
      'dayDBDpFRTfUfjX@~QLr@!gJU@E`dru@_SX eMHbeIXH#IZbyAr@ IZnHP Qv#!R_`CW?Hc|uwvH_Wx?u?p]dhH !R_`BH?M_|bGt]vhH !R_rq?Dqwz?@',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 28',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Acyl urea fragmentation',
    rxnCode:
      'dayD@DpFRYVZi`CyDsH@!gCiADEJSM@_Q\\ gCi@DDeV@`#IxliAZ@ qZt IxjD#!R_`CW?Hc|uwvH_Wx?u?p]dhH !Ru?q~@M]}GYjB !R_wy?_gvwGWh|',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 29',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Acyl urea fragmentation',
    rxnCode:
      'deeDBDpNRTfYYZjZ@OdRL`!eF@HhP dayDBDpFRTfUfjX@~QLr@#IaLJfxYT IU` IaLJnFP#!Rog~po[^}og~pOK\\|lGvw_[C}G]Kl !R_vp]Fgp !Roe~HoY^}bOrW?Kx@bKt]~mp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 30',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ketones fragmentation',
    rxnCode:
      'gJQA@IRYZ`OhH@!eMHbeIXH eF@Hp_Q@#qJfh qJp qe#!R_`BH?M_|bGt]lhH !R@Fp@XquZ?@ !R_rp]^op',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 31',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ketones fragmentation',
    rxnCode:
      'gJQA@IRYZ`OhH@!eMHAIXOj` eF@bXpP#qNU` qNh QX#!R_g~w?_C}mwp]tmp !R_rq?DqvZ?@ !R_rp]^op',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 32',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ethers fragmentation',
    rxnCode:
      'gCaA@IRfhCzBLrUXe@!eFHBLGtP eF@bXpZph#qVa QX qq#!R@Fp_[@ACGWI| !R_pp]Vop !R@DL]^gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 33',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ethers fragmentation',
    rxnCode:
      'gCaA@IRfhC{BIF`!eFH`fLGtX eF@HhP#qVa QX qN#!R@Fp_[@ACGPk| !R_pp]vop !R_pp]^op',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 34',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ethers fragmentation',
    rxnCode:
      'gJQA@IRej`OdHd@!eMH`eIXOh` eF@Hp_Q@#qTuH qTh qq#!R@Fq_[@@cWrL]Lop !R_tq?DquZ?@ !R@BL]~kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 35',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Oxime-ethers fragmentation',
    rxnCode:
      'gNyAHIJTkTu@_JPhjbjj@!gChA@IRYhCzCJjJR` eMHAIXH#qiZ~` qJf qkx#!Rm{wpoWy?|Grw__A}GSI\\ !R_g?p?[_}GUk\\ !R@FL@[Awz_@',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 36',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Phosphates fragmentation',
    rxnCode:
      'diDBbHSBCpbTjmUjj`CzH`!gNpYHlQxRTjmZj@~T`p eF@HhP#IJlXTzX IJa[Ix Qd#!Rm?vw_Gy?|Grw?_A}|Ovw_AuRO@ !RXs|?[@Al[C|?XpAcG]j| !R@FL]Agp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 37A&B',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Phosphates fragmentation',
    rxnCode:
      'daxBbHSBCpRTjmVjh@~aH@!gGQiHlO@ReVmTA@ eFHBLGtP#IaLJa[` qbi{ IpP#!RmwvwOKy?lCqw_[B}lGt]dcp !RHu}_[@AlWrL@HquZo@ !R_vp]Aop',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 38',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Phosphates fragmentation',
    rxnCode:
      'gNpYHlQxJ\\ddqZj@~rcPX@!gJPXHlQxQ{TA}eF`p eF@bXpP#qqU\\x qqUX qg#!RHu|@Hu}l[@@@[@@cG[I| !Ro`BWo[y_bKt]vgp !R_tp]~op',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 40',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Phosphonic acid fragmentation',
    rxnCode:
      'gGPiHaxJ\\ddKU@_QX!gC`iHaxJX{PGrDK@ eF@HhP#qqZl qq] Qd#!R[@AcOs}l@FL?XqwR_@ !R_`CW_Xa}GUk| !R@FL]~gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 41&42',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Phosphonic acid fragmentation',
    rxnCode:
      'gGQiHlOASddeZhCyKM@!gCahHlOBNtA}aBcP eF@bXpP#qVLk qVa qk#!RHpAlWu|c@Fp@Hqvr_@ !RoY\\@okvHG]i| !Ry`@]^`H',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 43',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Phosphonic acid fragmentation',
    rxnCode:
      'gJQiHlOASGmPGrVZ@!gC`iHaxBX{PGtT@ fI@Gu`#qbqh qbM Qp#!Ruwu~@Gx?bGt]Lgp !Ruwu~@Ha}GYk| !RGWi|',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 44',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate A fragmentation',
    rxnCode:
      'daxLRDp`BH|DeIiUjj@Mh[tI@!gGPeE`DSpdiLkU@[P` eFHBLGtP#IqBaak` qrco IHP#!R|Gq~_{]||Gsp_[]}|Gt]lgp !R_`CW?Hc|uwvH_QuZ`` !R@FL]Akp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 45',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate A fragmentation',
    rxnCode:
      'diDLRDp`BH|DeIiUZjh@~aH@!gNqeEb@b^AeIiVj`Oh\\@ eF@HhP#IRBra[i qTnOX IdP#!R_`BH_]]}_`BH@m\\Bu?rH_Qtrp` !RXp@?[@AlXs|?XpAcG]jB !R_rp]Agp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 46',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate A fragmentation',
    rxnCode:
      'diDLRDp`BH|DeIiWZjh@~aH@!gNpdE`DSpRYUjdCzR@ eFH`fLGtX#IKDZhxY IKFkad QX#!R_`CW_Xa}_`CW@h`Bu?rH_QvRp` !R_`CW@h`BuwvH_]\\BGUjB !R_rp]Aop',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 47',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate A fragmentation',
    rxnCode:
      'daxLRDp`BH|DeIiUjj@OhR@!gGPeE`DSpdiLkU@P eFHBLGtP#IqHha[` qri_ I`P#!R|Gq~_{]||Gsp_[]}|Gt]Bgp !R_w{}m?wp_K]||AuZ_@ !RjW|]^cp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 48',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate B fragmentation',
    rxnCode:
      'diDLRLJ`BH|@eJZ]ijh@~`H@!gNqdEb@b^BSVsU@_PP eF@bXpP#IaLJfxY IaBiad qw#!R|Gvw_[_}_g?p_K]||Gwp_QwRW@ !RXpAcOs}l@Fp?XpAcGUjB !R@FL]Akp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 49',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate B fragmentation',
    rxnCode:
      'diDLRLJ`BH|@eJZ]ijh@~`H@!gNqeEb@b^@eIkYj`OhL@ eF@HhP#IaLJfxY IaBZiD q~#!R|Gvw_[_}_g?p_K]||Gwp_QtrW@ !RXpAcOs}l@Fp?XpAcG]jB !R@FL]Agp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 50',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphate B fragmentation',
    rxnCode:
      'daxLRLJ`BH|@gIEHUSU@GtA@!gGQiHlO@ReVmTA@ eFB@HcA}D@#IaLJfxP IPfh^ Ql#!R|Ovw?[]}_g?p_OA}|Gt]Lep !R_g~w_OA|mwwp_QuZo@ !R_rp]~op',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 51',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Dithiophosphates fragmentation',
    rxnCode:
      'diDDrLH@bOA@aIRZUVjj@OhR@!gNplLPDSpPPdukUPGtT@ eF@bXpP#IyHKAii qzfKh IFP#!R_`BH_]]}_`BH@m\\Bu?rH_Qtrp` !R[@AlOs}l@Fp?XpAcGSjB !R_rp]Aop',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 52',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Dithiophosphates fragmentation',
    rxnCode:
      'daxDrLH@bOA@aIRZUZj`CzD`!gGPeE`DSpdiLkU@P eFB@HcA}D@#IaLJfxP IaBka qs#!R|Grw_Gy?|Grw__A}|Gt]Lgp !R_`CW?Hc|uwvH_QuZ`` !R_rp]~op',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 53',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Dithiophosphates fragmentation',
    rxnCode:
      'diDDrLH@bOA@aIRZUVjj@OhR@!gNpmLPDSpPPiRZujhCzK@ eF@HhP#IaLJfxY IaLhax Ie`#!R_`BH_]]}_`BH@m\\Bu?rH_Qtrp` !R[@AlOs}l@Fp?XpAcGSjB !R@FL]Agp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 54',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aminothiophosphates fragmentation',
    rxnCode:
      'diFDbLa@|LeJiVjZh@~cHcAHHA@!gGPiHaxBTjVf`LYdD@` eM`BN`~b@#IRbcFxY qUN_ I`Y#!Rmwsp_Gy?mwvw__A}mwwp_QvRO@ !Rmwsp_Gy?mwwp_QuZo@ !ROvL@XqtFo@',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 55',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aminothiophosphates fragmentation',
    rxnCode:
      'dazDbLa@|LeJiVij@OhsHpRB@P!gGPhHaxITmM@_PQFYA@H@ eF``fJGtX#IaLJfxP qbu_ IHP#!Rmwq~_?A|mwvw?_A}|Ot]dcp !Rmwsp_Gy?mwwp_QuZo@ !R_rp]Aop',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 56',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aminothiophosphates fragmentation',
    rxnCode:
      'diFDbLa@|LgIIDeZfj@OhsHpRB@P!gNxiMDOCReTmSPGtwQaPPB@ eF@HhP#IaLJfxY qbqkx IdP#!Ruwu~@Ha}_c?W?M_|bOrH_Qtr?@ !ROvp@[Fp?Xs|?XpAcG]j| !R@FL]Agp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 57',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aminodithiophosphate fragmentation',
    rxnCode:
      'dazHrBp@bOA@aIRZUZj`CyD`h@!gGYEL`DSpdiLkU@_SP eFB@HcA}D@#IKFiNF@ IKJPX q_#!R|Gsp_Gy?mwsp__A}mwt]lgp !R_`BH?M_|bGwW_QuZ`` !R@FL]Akp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 58',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Phosphonates fragmentation',
    rxnCode:
      'daxLbHS@|HeJkUjj@OdbBp!gGQhHlOAJejhCzZ@ eF@bXpP#IpdkhXP qric IxP#!Rmwvw_Gy?|Grw?_A}|Ot]Tcp !Rmwsp_Gy?mwwp_QuZo@ !R_rp]~op',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 59',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Thiophosphonates fragmentation',
    rxnCode:
      'gGPiH`DR\\ddJu@_JQl@!gC`hH`DQv`Ohh@ eF@bXpP#qqj\\ quK QX#!R[@AcOs}l@FL?Xqtr_@ !R_]\\@_gvHGSi| !RjW|]~cp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 60',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Sulfides fragmentation',
    rxnCode:
      'gC`I@DBTij@~``!eFB@HcA}D@ eF@bXpP#qTq Q\\ qa#!R@Fp?[@AcG_K| !R@FL]Vkp !R_rp]nop',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 61',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Sulfides fragmentation',
    rxnCode:
      'gC`I@DBTij@~``!eFB`HIcA}F@ eF@HhP#qrL qq Qd#!ROvL@Xs}lGSJ| !R_rp]Vop !R_rp]^gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 62',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aminosulphate fragmentation',
    rxnCode:
      'gGXiMD@cSddaVhCz[@!gC`iH`DBXzpD eF`BLGtX#qqj\\ qqk QX#!R[@AcOs}l@FL?XquR_@ !RuwvH_Wx@GYk| !R_rp]^op',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 63',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aminosulphate fragmentation',
    rxnCode:
      'gNxiMD@cSddaRuPGtv@!gJPhH`DYIBl`P eF``fLGt\\#qqj\\x qqkx QX#!R[C}cOs}l@Fp?XpAcG]J| !Rmwq~_?A||Gt]vkp !R@FL]~kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 64',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Sulfoxides fragmentation',
    rxnCode:
      'gJQIH@`ReVu@_HPl@!eMJHBHvCzH@ eF@bXpP#qqU` qqh QX#!R_`CW_Xa}upH]top !R@FL?XquZo@ !R_rp]^op',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 65',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Sulfones fragmentation',
    rxnCode:
      'gGPiH`DR\\ddJu@_JQl@!gC`hH`DQv`Ohh@ eF@bXpP#qqj\\ quK QX#!RPSPQzqpe_sd||avr_@ !RGi}nhG}{GUi| !Rx@@]~`H',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 66',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Sulfites fragmentation',
    rxnCode:
      'gNqiHl@aReVkUPGtT@!gJQhHl@aJmj@~f` eF@bXpP#qqUcx qqjX qg#!R_`BH_]]}bOsW?Ha}G_K| !R@Gy}bGwW@h`]N`H !RjW|]~cp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 68',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Water elimination',
    rxnCode:
      'gCiALAJRu@_HYlgHE@!fI@Gu` eO``fNZ`~cIrE@#qNT qH Qg#!R@FL@[@AcGPj| !RG]i| !R_g~w?Qwzo@',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
  },
  {
    label: 'Water elimination',
    rxnCode:
      'eMH`eIXOda`!fI@Gu` eF@bXhP#Qy Qp Qd#!R@Fp@XqtJ_@ !RG]i| !R@FL]^gp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
  },
  {
    label: 'Inductive cleavages assisted by β-hydrogen removal',
    rxnCode:
      'dayHBDxDeIYtjj@OdRJ`!gCi@DDeZ@~b` gChA@IRVdCzB@#IyjH\\R@ IyjD qbq#!R|Gsp?_A|_g?p?_A||Ot]|kp !R@FL@[@AcGSi| !R@FL@[@AcGXY|',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.4',
    description: 'Fig 23 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'eMhdYRRCJW}N@!fJ@D eFH`fND#Qg Qp Qd#!R@Fp@HqvJ_@ !RGUi| !R@BL]ngp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'eMDaYRRCJW}LQeA@H@!fI@FL``D@ eFH`fND#Qg Qp Qd#!R@Fp@PqvJ_@ !RGUi| !R@DL]^gp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'gChA@Icu@YPOYQ^`bNB\\GaHXECAjb@!fJ@FLgAx@ fHT`P#Q`P a` QP#!ROg?Po[^}G_H| !RGUi| !RGWi|',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'eFH`fLFTOzLcBB@P!fI@GudYA@H@ fHT`P#Qd a` QP#!R@BL]\\gp !RGUi| !RGWi|',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.1',
    description: 'Fig 22 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'gGYALMJT}TpGRdX!gJY@DDefXB fHT`P#qnZa qnTH qX#!RbOvw?X`B?`BH?Qur?@ !RbOvH@ox@bOt]Nop !RG_i|',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 32 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'diD@b@|@gIIETjji@NlRrJ@!gC`HAxQz`H eM@fXvB eF@HhP#IaLJfxY qan IF^ qS#!R@AMl@G}lDw|@[@@S@Fp@Dqvr_@ !Rm?w~@Hc}GYk| !R_qL@DquzO@ !R@AL]akp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 31',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'dazHBLCIRfVjY`CiBfoQT@!gGYADEJSLtpD eF@HhP#IqBZJG` IqF`^ qM#!RbOvw?X`B?g~w@ox@bOt]lkp !RbOvH@oy??`BH?Qvzo@ !R@AL]Akp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 32 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Grob-Wharton',
    rxnCode:
      'gNpaIYJU_MU@_JQXbh``DUA@H@!gCa@IGj@~dbLbB@P eMHjfM`~jHt``D@#qqWeX qqW qeX#!RmwvH_Wx@b@I~@Ha}G[K| !Rm?u~@Ha}GUi| !R_qL@XquzO@',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.5',
    description: 'Fig. 24 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gJXA@IRmZ`OdHL@!eM`bfN`~b@ eF@HhP#qTqh Q^ qi#!R_qL@DpAl@AL]Bkp !R_qL@DqwZo@ !R@AL]Akp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gChA@Icu@_PP!fH@H eM``fM`~b@#qTq qH Q[#!Rm?w~@Hc}GWK| !RG[i| !R_qL@DquZ_@',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
  },
  {
    label: 'Displacement Reaction b.',
    rxnCode:
      'gJXA@IRUjPH!eM@fXvB eF`BLGtP#qlVH qrH ql#!R@Fp@DpAl@AL]Bgp !R_qL@DqwZO@ !R@AL]~gp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Displacement Reaction b.',
    rxnCode:
      'gJQABYRmZ`LXTD@`!eM@fXvB eFH`fLGtQFDD@`#qMr` qNh Qd#!R@FM?Dw|\\_qL]dcp !ROvL@XqwZO@ !R@FL]~gp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '4.1',
    description: 'Fig. 7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Displacement Reaction a.',
    rxnCode:
      'gGYADEJSLuPGtT_nlK|!gChA@Icu@_PP eFHBND#qtSi qQ] Qx#!RbOvH@oy??`BH?QtJo@ !Rm?w~@Hc}GUk| !R@AL]^gp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7.1.3',
    description: 'Fig. 22 c. ',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Grob-Wharton',
    rxnCode:
      'gNxaLJIRU[jXCzZ@!eMH`eIxH eF`BJGtP eFHBND#q{iV` Qv qM q{#!R?g?~_xc}b@K~@Hc}G]H\\ !R_?y??auj_@ !R@AL]ngp !R@AL]Agp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '6.1.5',
    description: 'Fig. 24 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'CO Elimination',
    rxnCode:
      'gCaA@IRWhCZZLtLG~s@!fHT`P eFHPfzND#Qg@ Qp Qd#!R?g?~_xc}G_H\\ !RGYi| !R@AL]nkp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'MassFrontier, need to find literature',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'gGPiH`DZ\\ddJu@XsHp\\@!gC`iH`DBXzpD eF@HhXpcAp@#qVLk qVM qc#!R[G|S@@Al_qL@Dqwr_@ !Rm?w~@Hc}G[k| !R_vp]Fgp',
    ionization: 'esiPositive',
    reaction: 'CMF',
    doi: 'https://doi.org/10.1002/rcm.9131',
    section: 'conclusion',
    description: 'scheme 1',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: '1,4-elimination',
    rxnCode:
      'gGP`DTjZj`OdhLQRPPBB``D@!eMHJM`qiA@H@ eMHJM`qiA@H@#qrka quX qTH#!Rb@Jw@gx?_`BH_Qvr@` !R_qL@XqvZO@ !R_qL@XquzO@',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig 15 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: '1,4-elimination',
    rxnCode:
      'diDD@LiJf_jjh@~KHjFchbfHHAEHHA@!gGP`HTkej`OhXbh``DEA@H@ eM@HvB#IJlX^RX IIjGi Q^#!Rm?wp?PD@mwq~_?A|m?wp?QuRo@ !R}pOp?_A|_g?p?QtzW@ !ROvL@XqtFo@',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig 15 d.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Water elimination',
    rxnCode:
      'eMHJN`pksPqFdD@`!fI@GudYA@H@ eF@HhP#Q^ Qp Qd#!RWrL@@qvrO@ !RG]i| !R@@L]~kp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.7',
    description: 'Fig. 18 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-heteroene (McLafferty-type rearrangement)',
    rxnCode:
      'gJQ@HeZu@_PqFQA@H@!eMHJN`~jHt``D@ eF@HhP#qMr` qMp Qd#!R_qL@XpAl@FL]Bcp !R_qL@XqwZO@ !R@FL]Akp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 12 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-heteroene (Claisen rearrangement)',
    rxnCode:
      'daxH@JrRHiMUHAcEHHA@!daxH@NrSRHmUHAcGHHA@#IZaxla@ IhfP^c@#!RmwvH_Wx@mpJw_]\\Buwt]Dgp !R@FM?Dw|\\[C}cOw|S_qp]vcp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 12 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'daxDBDqIRiubJ`CZN|bPtQqDD@cDD@chXO}c`!gJQ@DeNl`XqHHA@ eFH`fLGtYFDD@`#qqj\\x qqkx QX#!RbKvAHI^}b@JW@kx@e{t]dop !R@BM?W@Al@BL]nop !R@BL]agp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig. 13 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'daDLBHSdeJmVfZjh@~QHzHyBB@PbB@QrB@P!gCaAIiRmhCFQA@H@ gC``Eh{PGrTZHiHHAFPPB@#Ikb[HPP I`Tp qky#!R}?spoGy?|OwpoWy?_g|]tep !R_qp@[@AcGUk| !RbGvw?Wx@G_k|',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 14 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-ene',
    rxnCode:
      'gJQ@DeZu@_PqFIA@HFB@!eMHJM`qiA@H@ eF@HhP#qeVH qbh qq#!ROvM@DpAl@FL]bcp !R_qL@XqwZO@ !R@FL]~kp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.3',
    description: 'Fig. 11 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'gOu@AReLm]SLAcB``D@!gJY@@TeVTCFEA@H@ eF`BJD#IKJRV` IZDrP qM#!R}xOp?Wy?}?q~_?B}GYI\\ !R_qq?Dw|\\_qp]z`H !R@FL]Agp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 d.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'gFx@@eJfuS@P!gC`@Die@` eF`BJD#q]aV qqU q\\#!R?g~w@k_}m?vw@auRO@ !R@Fq?[@@SGUk| !R@AL]^gp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'gFp@DiTujhB!gC`@Die@` eF@HhP#q]aV q]a Q\\#!R?g~w@k_}m?vw@auRO@ !R@Fq?[@@SGUk| !R@AL]^kp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'daDD@DqJg^ffZh@qQDD@cDD@`!gGQ@BeJmJHGFEA@H@ eFHBJFLHHA@#IGmdehp IxakS IeP#!R_g?w@oB||Kwp?_A||Ot]lkp !R|OtA@OA|}pKp?QwZ`` !R@FL]Agp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 10 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Remote Hydrogen rearrangement',
    rxnCode:
      'eM@jXvCFdD@`!fH@Oj@ eF@bXxXp``D@#Qg Qp QX#!R_qL@DqtrO@ !RGUi| !R@AL]ngp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '3',
    description: 'Fig. 4.1. b',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Remote Hydrogen rearrangement',
    rxnCode:
      'eMHJN`~ZFHt``D@!fI@GudYA@H@ eF@HhP#Q[ a` Qt#!R_qL@XqwrO@ !RG]i| !R@FL]^kp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.1',
    description: 'Fig. 8 a. & b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode:
      'gCaA@IRmhCzZHpHHA@!eFH`fJGtQFDD@` eF@HhP#qqT qq Qd#!ROvp@[@AcGPi| !R@FL]vgp !R@FL]~kp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: '',
    section: '7.4.1.3.',
    description: 'Fig. 7.7',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
  },
  {
    label: 'Hydrogen elimination',
    rxnCode:
      'gFpACJTj[ATA}C`!gFpAAJTjZ@@A@#qbqk qn\\J#!R_g~w_K_}mwvw_AurO@ !R_g~w_K_}mwvw_AuZO@',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gJPaAaJTkTHGyZCDTDD@cHHA@!eMDiicXOfabKHHAB``D@ eF@HhP#qbqh qTH qu#!RupJH@gx@bGt]\\hH !R_qL@XqwZO@ !R@FL]Akp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
  },
  {
    label: 'Double cleavage',
    rxnCode:
      'gChA@IRmhCzB@!eF``fJGtX eF@HhP#qTq QX qq#!R_vp@[@@SG_I| !R@AL]Vgp !R@AL]^kp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: '',
    section: '7.4.3.',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
  },
  {
    label: 'Cycloreversion',
    rxnCode:
      'gFp@DiTvjhB!eF@HhP eF@HhP eF@HhP#qcUq Qd qk qN#!R?g~w@k_}m?vw@avRO@ !R@AL]Fkp !R@AL]Nkp !R@AL]~kp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.7',
    description: 'Fig. 17 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-heteroene (McLafferty-type rearrangement)',
    rxnCode:
      'gNpiIahRTeVfjDe}KDYDD@`!gC`iIahRTefDe}MDYDD@` eM@HvB#qbqkx qar qkx#!RbOvH@hc}b@K~@Hc}G_K| !R@AL@[@@SG[j| !R_qL@DqtFo@',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 12 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'gGP`MTj}jPOihbl``DUA@H@!eMHJMPqiA@H@ eMHFM`~fHr``D@#qStM qTX qNh#!RbGvw_Wx@mpJw?QvR?@ !R@@E?_awz_@ !R@FM?DquZO@',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.4',
    description: 'Fig. 14 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Aromatic elimination',
    rxnCode:
      'ded@@DiUU`hJ@H!gFp@DiTt@@B gC`@DiZDC@#IpdjFGiT qcUq IGiT#!RbKwWoX`B_c}~@M^}bOq~Owx@GWJ| !R_g~w_K_}m?vw_AvZO@ !R|Gq~_?C}GPZ|',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.6',
    description: 'Fig. 16',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Sigmatropic rearrangement',
    rxnCode: 'eM@HvCzX@!eM@HvB#Q^ Q[#!R_qL@DquJO@ !R_qL@Dqtzo@',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.7',
    description: 'Fig. 18 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-heteroene',
    rxnCode:
      'gGY@DDf]j`Odkl@!gCi@DDff@~`l eF@HhP#qrLk qrL qk#!Rb@JH?_x@b@JH?QuJ@` !Rb@K~@Hc}GSjB !R@AL]~kp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.5',
    description: 'Fig. 13 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'fdeA`D@\\brTfYY_m]gIZ|DhJB@@h@@~aF@!didHB@BTfUvfZVV@OhB@ didD@@iIYgxUie`B#iup`jXdibCPcXKoI iSxKhvMHP IwbkEYH#!RbKvH?Gx?bKu~@Hb}_c~H?Hc|_c}~@Hb}u{u~Owx?uwu~OquRS@ !R|GwpoGy?|GwpoWy?|GwpoQwZg@ !Rm?vw?Wy?mwsp_[]}m?vw_AuzG@',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 9 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'didDB@{iRYefxiJH@zRhX!gNpaAQJRs\\dBIzQg@ eF@HhP#IwlDdeZ IwlIEh IFP#!RbCvH?Ky_bCv~@H`}oe~H?Awro@ !Rmwvw_[y?msrpo[^}GSh\\ !R@BL]fkp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 9 a.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Retro-Diels–Alder ',
    rxnCode:
      'deTDB@{iRYemnJPb`CiJaoQt@!gGPa@QJRmsPbX gC`@DiPDCteZ@#IaLJfxYT IaBxU IriX#!RbOvH?Oy?bOw~@Ha}?g~H?Oy?G[I\\ !RbOvH?X`B?`BH?Qtz_@ !Rb@K~_xc}GXX|',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.2',
    description: 'Fig. 9 c.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Remote hydrogen rearrangement',
    rxnCode:
      'diD@b@|@gIIETjji@NlRrJ}DP!gGPIAxBTjfjPH eM@HvB#IZnFRqH IZagb Q^#!R@AMl@G}lDw|@[@@S@Fp@Dqwr_@ !R@FpS@G|S[G|@Dqtz_@ !R_qL@DqtFo@',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '7',
    description: 'Fig. 31',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Remote Hydrogen rearrangement',
    rxnCode:
      'dcN@B@J\\bRbRaWCUUUL@_ITC@!gFpAEJTjZuRA@ eM`AIhH eM@HvB#IO^adkBFU qb^i IO^ IeQ#!RbGvH@ha}bOs~_xa}bGw~_xc|?`BH?Awro@ !R?g~w@k_}m?vw@atZo@ !R@Fp@Dqwz_@ !R_qL@DqvFo@',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.1',
    description: 'Fig. 8 d.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Cycloreversion',
    rxnCode:
      'gFpAAJTj[UTA@!eF@bXhP eF@HhP eF@HhP#q\\jN q] qN Qd#!R?g~w@k_}m?vw@avRO@ !R@AL]Fgp !R@AL]Nkp !R@AL]~kp',
    ionization: 'esiPositive',
    reaction: 'CRF',
    doi: 'https://doi.org/10.1039/C5NP00073D',
    section: '5.7',
    description: 'Fig. 17 b.',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'CO loss',
    rxnCode:
      'gOxaBDYR[fmjj@pb}C@!gJYABCJRkTA}C@ eFHPfzND#qbqkx qq_h Qd#!RupKW_Wx@iJSkiNndG^KB !R_rq?Dw|l_qL]zop !R_rp]~op',
    ionization: 'esiPositive',
    reaction: '',
    doi: 'https://doi.org/10.1038/s41598-019-42777-8',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'COOH loss',
    rxnCode:
      'gOxaBDYR[fmjj@pb}C@!gBXA@IReYj@` eMDARVCzX@#qbqkx qi{ Qg#!Rb@I~@Ha}HKjzG{h_GPhB !R_`@@_`A~GUhB !R_rq?Dqvz_@',
    ionization: 'esiPositive',
    reaction: '',
    doi: 'https://doi.org/10.1038/s41598-019-42777-8',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Tropylium rearragement',
    rxnCode:
      'gOpAMJUKua@@Gtt@!gOpAGJTju`@@Gt\\@#qgVMX qYoTp#!Ryst~@H`}y?sg?Cx@GPhB !ROg}GUD]swqg_AlvOGUh|',
    ionization: 'esiPositive',
    reaction: 'Rearrangement',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: 'ISBN: 978-0-470-03310-4',
  },
  {
    label: 'Tropylium fragmentation',
    rxnCode:
      'gOpAGJTju`@@D!gKPACJTnLE@P eF@HxP#qqUcx qMsx Qd#!R{xXxCBvpo`AblGlLG[KB !RKrV~@FLXKvh]FhH !R@BL]^kp',
    ionization: 'esiPositive',
    reaction: '',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: 'http://people.whitman.edu/~dunnivfm/C_MS_Ebook/CH6/6_9_5.html',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Tropylium fragmentation',
    rxnCode:
      'gFpAAJTjZ@@A@!gBPAAJTkRpD eF@HxP#qbqk qbu qY#!RtCvwOSy?Og~wOQurW@ !R@Cx~Gsx_GUj| !R@DL]^kp',
    ionization: 'esiPositive',
    reaction: '',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'alpha cleavage',
    rxnCode: 'eM``eIhOh`!fH@Oj@ eF``fJD#Qg Qp Qd#!RPNp@Pqur_@ !RGUi| !R@p@]nop',
    ionization: 'esiPositive',
    reaction: '',
    doi: 'https://doi.org/10.1149/1945-7111/abdde7',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Dioxolane fragmentation',
    rxnCode:
      'detDB@jYRfUwJxZB@h@H!eFHBJD daDHB@RTfUVyiZPB#IaLJfxYT Ql IXdziEP#!Rim~?Sk]}bGwMs?y??g~H_Xa}GSKl !R@AL]fgp !RbOuh{IE?hJUDZpio`CX]Aep',
    ionization: 'esiPositive',
    reaction: '',
    doi: '10.1039/C3AY40543E',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Rearrangment a',
    rxnCode:
      'dnD@BLeJV|jfZih@`!gOpAGJTju`@@D#qTuYx qigSp#!RKF\\_YUMg_?{~_?y?G_I\\ !Rw|XxCFvp?`@RlD\\LG]kB',
    ionization: 'esiPositive',
    reaction: '',
    doi: 'https://doi.org/10.1016/j.comptc.2016.07.018',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Rearrangment d',
    rxnCode:
      'gOpAIJUKua@@Gtt@!gOpAMJUKua@@D#q]gJp q\\oQp#!R_`CW_Xa}u?sW?M]}GPhB !Ru{u~@Hb}upKW@gx@GShB',
    ionization: 'esiPositive',
    reaction: '',
    doi: 'https://doi.org/10.1016/j.comptc.2016.07.018',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Inductive cleavage',
    rxnCode: 'eM@bXzCzh@!fHT`P eF@HhP#Q^ a` Q\\#!R@AM?DquJo@ !RGQi| !R@AL]nkp',
    ionization: 'esiPositive',
    reaction: '',
    doi: 'https://doi.org/10.1093/chromsci/43.2.92',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Dioxolane fragmentation',
    rxnCode:
      'dclDB@iYRfUw\\kahHBj@CzI`!eFHBJD deTHB@RTfU]ih@I`Hz~`H@#IzAQirbWS IdP IzD[JI]L#!Rim~?Sk]}bGwMs?y??g~H_Xa}b@JH_QwR{@ !R@AL]agp !Rb@K~@Hc}b@JH@hc}bOvH@hc}GWjB',
    ionization: 'esiPositive',
    reaction: '',
    doi: 'https://doi.org/10.1002/jms.1963',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Elimination',
    rxnCode: 'eM`AIhOdq`!fJ@Gup eF@HhP#Qv Qp Qd#!R_vq?Dqwr_@ !RG[i| !R@AL]fkp',
    ionization: 'esiPositive',
    reaction: '',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Elimination',
    rxnCode:
      'gC`@Dij@~b`!eF@Hp_Q@ eF@HhP#qVa qq Qd#!R@Fq?[@@SGXhB !R@AL]ngp !R@AL]fkp',
    ionization: 'esiPositive',
    reaction: '',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'DB rearrangement',
    rxnCode: 'eM@HvCzX@!eM@HvCzX@#Q[ Q^#!R_qL@DqtjO@ !R@AM?DquZO@',
    ionization: 'esiPositive',
    reaction: '',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Oxonium Resonance',
    rxnCode: 'eFH`fJGtQFDD@`!eFHhfLGuQFdD@`#QX Qd#!R@FL]bgp !R_qp]Vop',
    ionization: 'esiPositive',
    reaction: 'Resonance',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: 'https://en.wikipedia.org/wiki/Oxonium_ion',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gC`a@aJRm@_PP!eMHAIhOh` eFH`fND#qbq qq@ Qd#!R@AL@[@@SG_I| !R@Fp@DqwZ_@ !R@AL]^gp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: '',
    section: '',
    description: '',
    kind: 'reaction',
    web: 'https://www.researchgate.net/figure/a-Chemical-structure-of-oxidative-reserpine-MW-6077-b-Post-source-decay_fig4_26637371',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Esters fragmentation',
    rxnCode:
      'gJP`@deVhCzF@!eMDARVCzX@ eF@HhP#qbuX Qg qk#!R@Fp@hpAl@JL]Rop !RbOr~@Atz`` !R@BL]Akp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 13',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Amines fragmentation',
    rxnCode:
      'gJX@@eSU@_PqUQRT!eM`BN`~bJhjT eF@HhP#qbqh qfH qU#!R|Grw_Gy?|Ot]|kp !ROvL@XquZ_@ !R@FL]^kp',
    ionization: 'esiPositive',
    reaction: 'reaction',
    doi: 'https://doi.org/10.1016/j.ijms.2010.10.024',
    section: 'Table 1',
    description: 'Rule 3',
    kind: 'reaction',
    web: '',
    mode: 'positive',
    isbn: '',
  },
  {
    label: 'Ionization',
    rxnCode:
      'gC``@deZ@~P]OdE@!gC`a@aJRm@_PV#qJf qJf#!RPAM@G@AcGXi| !RPAM@G@AcG[i|',
    ionization: 'esiPositive',
    reaction: 'Ionisation ',
    doi: 'https://doi.org/10.1186/1477-5956-10-S1-S8',
    section: '',
    description: '',
    kind: 'ionization',
    web: '',
    mode: 'positive',
    isbn: '',
  },
];
